export const exposures = {
    PRIVATE: 1,
    PUBLIC: 2
}